import api from 'api';
import Theme from 'records/Theme';
import { DesignTemplates } from 'records/DesignTemplate';

export const THEMES_OCCASION_ASYNC_ACTION_START = 'THEMES_OCCASION_ASYNC_ACTION_START';
export const THEMES_OCCASION_ASYNC_ACTION_SUCCESS = 'THEMES_OCCASION_ASYNC_ACTION_SUCCESS';
export const THEMES_OCCASION_ASYNC_ACTION_ERROR = 'THEMES_OCCASION_ASYNC_ACTION_ERROR';
export const THEMES_OCCASION_RESET_STATE = 'THEMES_OCCASION_RESET_STATE';

const s3BucketURL = APP_CONFIG.s3BucketURL;

function themesOccasionAsyncActionStart() {
  return {
    type: THEMES_OCCASION_ASYNC_ACTION_START,
  };
}

function themesOccasionAsyncActionSuccess(data) {
  return {
    type: THEMES_OCCASION_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function themesOccasionAsyncActionError(error) {
  return {
    type: THEMES_OCCASION_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetThemesOccasionState() {
  return {
    type: THEMES_OCCASION_RESET_STATE,
  };
}

export function getThemesOccasionAsync(isOccasion, designtid, sizeid, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesOccasionAsyncActionStart());
    return api.request(`theme/list?isOccasion=${ isOccasion }&designtid=${ designtid }&sizeid=${ sizeid }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
    	data.map((themesGraphicCategory) => {
	  		themesGraphicCategory.imageURL = `${ s3BucketURL }`+'system/theme-images/'+themesGraphicCategory.typeItemTextKey+'.png';
	  		themesGraphicCategory.iconURL = `${ s3BucketURL }`+'system/theme-icons/'+themesGraphicCategory.typeItemTextKey+'.png';
		    });
      dispatch(themesOccasionAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(themesOccasionAsyncActionError('Unable to get Occasion Themes'));
      throw (err);
    });
  };
}

export function getThemesOccasionThemeAsync(isOccasion, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesOccasionAsyncActionStart());
    return api.request(`theme/list?isOccasion=${ isOccasion }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
    	data.map((themesGraphicCategory) => {
	  		themesGraphicCategory.imageURL = `${ s3BucketURL }`+'system/theme-images/'+themesGraphicCategory.typeItemTextKey+'.png';
	  		themesGraphicCategory.iconURL = `${ s3BucketURL }`+'system/theme-icons/'+themesGraphicCategory.typeItemTextKey+'.png';
		    });
      dispatch(themesOccasionAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(themesOccasionAsyncActionError('Unable to get Occasion Themes'));
      throw (err);
    });
  };
}

export function getOneThemeOccasionAsync(themeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesOccasionAsyncActionStart());
    return api.request(`theme/design/DesignTemplates?themeid=${ themeId }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
      let typeItemOccasionData = getState().themesOccasion.get('data');
      let themeOccasionData = Theme.getThemeDataByTypeItemId(typeItemOccasionData, themeId).first().setIn(['designTemplates'], DesignTemplates(data));
      let replacedData = Theme.setThemeDataByTypeItemId(typeItemOccasionData, themeId, themeOccasionData.get('designTemplates'));

      dispatch(themesOccasionAsyncActionSuccess(replacedData));
      return themeOccasionData;
    })
    .catch((err) => {
      dispatch(themesOccasionAsyncActionError('Unable to get Occasion Theme'));
      throw (err);
    });
  };
}
